export default {"src":"/_next/static/media/Maggie.cc0ed5fe.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};